import { Box, Container, Link, Tab, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import TagOutlinedIcon from "@mui/icons-material/TagOutlined";
import React, { useEffect, useState } from "react";
import TabContext from "@mui/lab/TabContext";
import { TabList, TabPanel } from "@mui/lab";
import Overview from "../../components/Block/Overview";
import Consensus from "../../components/Block/Consensus";
import Mev from "../../components/Block/Mev";
import { useParams } from "react-router-dom";
import { useUpcxChain } from "../../hook/useUpcxChain";
import { GetBlockResult } from "upcx-js/dist/upcxjs-rpc-interfaces";

const Block = () => {
  const [value, setValue] = React.useState("1");
  const { jsonRpc } = useUpcxChain();
  const { id } = useParams();
  const [block, setBlock] = useState<GetBlockResult>();

  const getBlockInfo = async () => {
    if (!id || !jsonRpc) return;
    const blockInfo = await jsonRpc.get_block(id);
    setBlock(blockInfo);
  };

  useEffect(() => {
    getBlockInfo();
    //eslint-disable-next-line
  }, [id, jsonRpc]);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <>
      <Container className="container-xxl">
        <Box className="d-flex flex-wrap justify-content-between align-items-center border-bottom gap-3 py-5">
          <Box className="d-flex flex-column gap-1">
            <Box className="d-flex flex-wrap align-items-center gap-1">
              <Typography className="h5 me-1 mb-0">Block</Typography>
              <Typography className="text-muted text-break">#{id}</Typography>
            </Box>
            <Box className="d-flex flex-wrap gap-1 text-break">
              <Link className="badge bg-white hover:bg-secondary border border-dark dark:border-white border-opacity-15 text-dark text-nowrap fw-medium transition-all rounded-pill py-1\.5 px-2 ">
                <Box className="d-flex align-items-center gap-1">
                  <TagOutlinedIcon className="badge-icon" fontSize="small" />

                  <span className="hash-tag text-truncate">Normal Block</span>

                  <InfoOutlinedIcon
                    className="ms-0.5 badge-icon"
                    fontSize="small"
                  />
                </Box>
              </Link>
            </Box>
          </Box>
        </Box>
      </Container>

      <Container className="container-xxl pt-2 pb-12">
        <Box sx={{ width: "100%", typography: "body1" }}>
          <TabContext value={value}>
            <Box className="py-3">
              <TabList
                onChange={handleChange}
                aria-label="Block Info Tab"
                className="normal-tab-group"
                indicatorColor="primary"
                textColor="inherit"
              >
                <Tab label="Overview" className="normal-tab" value="1" />
                {/* <Tab label="Consensus Info" className="normal-tab" value="2" />
                <Tab label="MEV Info" className="normal-tab" value="3" /> */}
              </TabList>
            </Box>
            <TabPanel value="1" className="p-0">
              <Overview block={block} />
            </TabPanel>
            <TabPanel value="2" className="p-0">
              <Consensus />
            </TabPanel>
            <TabPanel value="3" className="p-0">
              <Mev />
            </TabPanel>
          </TabContext>
        </Box>
      </Container>
    </>
  );
};

export default Block;
